import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  console.log('API Request - Token:', token ? 'Present' : 'Missing');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const productService = {
  // Get all products with filters
  async getProducts(filters = {}) {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const response = await api.get(`/products?${params}`);
    // Backend returns { products: [...], pagination: {...} }
    return response.data.products || response.data;
  },

  // Get product by ID
  async getProduct(id) {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  // Get product categories
  async getCategories() {
    const response = await api.get('/products/categories/list');
    // Backend returns array directly for categories
    return Array.isArray(response.data) ? response.data : [];
  },

  // Search products
  async searchProducts(query, limit = 10) {
    const response = await api.get(`/products/search/${query}?limit=${limit}`);
    // Backend returns array directly for search
    return Array.isArray(response.data) ? response.data : [];
  },

  // Get products by pharmacy
  async getProductsByPharmacy(pharmacyId, filters = {}) {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const response = await api.get(`/products/pharmacy/${pharmacyId}?${params}`);
    return response.data;
  },

  // Pharmacy: Add product
  async addProduct(productData) {
    const formData = new FormData();
    Object.keys(productData).forEach(key => {
      if (key === 'images' && Array.isArray(productData[key])) {
        productData[key].forEach((image, index) => {
          formData.append('images', image);
        });
      } else if (key !== 'images') {
        formData.append(key, productData[key]);
      }
    });

    const response = await api.post('/products', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Pharmacy: Get my products
  async getMyProducts() {
    const response = await api.get('/products/pharmacy/my');
    return response.data;
  },

  // Pharmacy: Update product
  async updateProduct(id, productData) {
    const response = await api.put(`/products/${id}`, productData);
    return response.data;
  },

  // Pharmacy: Delete product
  async deleteProduct(id) {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  }
};

export default productService;
